import * as React from 'react';
import type { QaTrackingEntityProps } from '@/shared/modules/qa-tracking-entity';
import * as Styled from './error-message.styled';
interface ErrorMessageProps {
  message: string;
  qaEntity?: QaTrackingEntityProps;
}
export const ErrorMessage = React.memo(function ErrorMessage({
  message,
  qaEntity
}: ErrorMessageProps) {
  return <Styled.Text {...qaEntity}>{message}</Styled.Text>;
});